import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DataForSEOHealthResponse {
  success: boolean;
  data: {
    healthy: boolean;
    message: string;
  };
  timestamp: string;
}

export interface UrlAnalysisResponse {
  success: boolean;
  data: {
    url: string;
    analysis: any | null;
    message?: string;
    status: 'completed' | 'pending';
  };
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataForSEOService {
  private readonly API_URL = environment.apiUrl + '/v1';

  constructor(private http: HttpClient) {}

  /**
   * Test DataForSEO connection (health check only).
   * Calls GET /api/v1/dataforseo/health.
   */
  testConnection(): Observable<DataForSEOHealthResponse> {
    return this.http.get<DataForSEOHealthResponse>(`${this.API_URL}/dataforseo/health`);
  }

  /**
   * Get the latest PageAnalysis for a specific URL from the database.
   * Calls GET /api/v1/urls/analysis?url=<encoded>.
   *
   * Note: Analyses are created server-side via the page comparison flow
   * (POST /api/v1/urls/compare → DataForSEO pingback → PageAnalysis).
   */
  getUrlAnalysis(url: string): Observable<UrlAnalysisResponse> {
    const encodedUrl = encodeURIComponent(url);
    return this.http.get<UrlAnalysisResponse>(`${this.API_URL}/urls/analysis?url=${encodedUrl}`);
  }
} 